import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import { Card } from '@totalsoft/rocket-ui';
import { LogPropertyContainer } from 'features/logs/components/LogStyles';
import GenericFilterParamLogXmlContentContainer from './GenericFilterParamLogXmlContentContainer';

const GenericFilterParamLogComponent = ({ data }) => {
  const { t } = useTranslation();

  return (
    <Card disablePadding>
      <Grid container>
        <Grid item container alignItems={'center'} pt={2} pb={1} px={3} xs={11} id={`genericLogItem_${data.id}`} spacing={1}>
          <LogPropertyContainer item xs={8} lg={4}>
            <span title={data.documentNumber}>
              <strong>{t('GenericFilterParamLogs.DocumentNumber')}:</strong>
              {data.documentNumber}
            </span>
          </LogPropertyContainer>

          <LogPropertyContainer item xs={8} lg={4}>
            <span title={data.documentType?.name}>
              <strong>{t('GenericFilterParamLogs.DocumentTypeName')}:</strong>
              {data.documentType?.name}
            </span>
          </LogPropertyContainer>

          <LogPropertyContainer item xs={8} lg={4}>
            <span title={data.method}>
              <strong>{t('GenericFilterParamLogs.Method')}:</strong>
              {data.method}
            </span>
          </LogPropertyContainer>

          <LogPropertyContainer item xs={8} lg={4}>
            <span title={data.operator}>
              <strong>{t('GenericFilterParamLogs.Operator')}:</strong>
              {data.operator}
            </span>
          </LogPropertyContainer>

          <LogPropertyContainer item xs={8} lg={4}>
            <span title={data.logDate}>
              <strong>{t('GenericFilterParamLogs.LogDate')}:</strong>
              {data.logDate}
            </span>
          </LogPropertyContainer>

          <LogPropertyContainer item xs={8} lg={4}>
            <span title={data.partnerId}>
              <strong>{t('GenericFilterParamLogs.PartnerId')}:</strong>
              {data.partnerId}
            </span>
          </LogPropertyContainer>
        </Grid>
        <Grid item container xs={1} justifyContent='end' alignSelf='center' pr={2}>
          <GenericFilterParamLogXmlContentContainer id={data.id} />
        </Grid>
      </Grid>
    </Card>
  );
};

GenericFilterParamLogComponent.propTypes = {
  data: PropTypes.object.isRequired
};

export default GenericFilterParamLogComponent;
